import { CommonModule } from "@angular/common";
import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";
import { Subject, takeUntil } from "rxjs";
import { AppGlobals } from "src/app/app.globals";
import { FeatureFlags } from "src/app/interfaces/enums/feature-flag";

type TagTab = {
  text: string;
  link: string;
  features?: FeatureFlags[];
};

/** Admin ▸ Tags: one page with a tab per tag catalog (#797, #4808). */
@Component({
  selector: "app-config-tags",
  imports: [CommonModule, RouterLink, RouterLinkActive, RouterOutlet],
  templateUrl: "./config-tags.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./config-tags.component.css"],
})
export class ConfigTagsComponent implements OnInit, OnDestroy {
  private readonly allTabs: TagTab[] = [
    { text: $localize`:@@tagsTabTasks:Tasks`, link: "tasks" },
    { text: $localize`:@@tagsTabContacts:Contacts`, link: "contacts" },
    { text: $localize`:@@tagsTabSpark:Spark`, link: "spark", features: [FeatureFlags.ProjectHub] },
  ];

  tabs: TagTab[] = [];

  private $unsubscribe = new Subject<void>();

  constructor(private appGlobals: AppGlobals) {}

  ngOnInit(): void {
    this.appGlobals.$features.pipe(takeUntil(this.$unsubscribe)).subscribe(() => {
      this.tabs = this.allTabs.filter(
        (tab) => tab.features?.every((feature) => AppGlobals.UserCan(feature)) ?? true
      );
    });
  }

  ngOnDestroy(): void {
    this.$unsubscribe.next();
    this.$unsubscribe.complete();
  }
}
